import dayjs from "dayjs";
import { apiRequest } from "../../../infrastructure/backendService";
import {
  CommonOutlinedButton,
  CustomCalendarTodayOutlinedIcon,
  CustomDatePicker,
  StyledDateContainer,
} from "../../common/StyledComponents/StyledFields";
import { ClipLoader } from "react-spinners";
import { useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { ValidationError, object, string } from "yup";
import styles from "../../contactUs/contactus.module.scss";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import apiPath from "../../../config/apiPaths.json";

interface ErrorMessageTypes {
  poojaWeek: string;
}
const getCurrentWeekMonday = () => {
  const now = dayjs();
  const dayOfWeek = now.day();
  const daysToMonday = (dayOfWeek + 6) % 7;
  return now.subtract(daysToMonday, 'day').startOf('day');
};
const BirthdayPoojaReport = ({ sendDataToParent, getReportData }: any) => {
  const [formData, setFormData] = useState({
    poojaWeek:  getCurrentWeekMonday().format("MM/DD/YYYY"),
  });

  const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({
    poojaWeek:"",
  });

  const validationSchema = object().shape({
    poojaWeek: string().required("Please select week is required"),
  });
  const [loading, setLoading] = useState(false);

  const handleBirthdayPoojaReport = async () => {
    let startDate = dayjs(formData.poojaWeek, "MM/DD/YYYY");
    let endDate = startDate.add(6, "day");
    let reqBody: any = {};
    reqBody.fromDate = startDate.format("MM/DD/YYYY");
    reqBody.toDate = endDate.format("MM/DD/YYYY");
    reqBody.deityName = "ALL";
    // reqBody.poojaId = 77;
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint:apiPath.birthdayPoojaReport,
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then(async (res) => {
        setLoading(false);
        sendDataToParent(true,{reqBody});
        const response = res.data.map((report:any)=>{
          let counter = 1
          return {
            ...report,
            userinfo:report.userinfo.map((userInfo:any)=>{
              return {
                "Sr.No":userInfo.sno || counter++,
                username:userInfo.username,
                dateofbirth:userInfo.dateofbirth,
                gothram:userInfo.gothram,
                nakshtram:userInfo.nakshtram,
                ...userInfo,
              }
            })
          }
        })
        // getReportData(res.data);
        getReportData(response);
        
      })

      .catch((err) => {});
  };

  const handleSave = async (): Promise<any> => {
    const errors: ErrorMessageTypes = {
      poojaWeek: "",
    };
    try {
      // Validate the form data against the validation schema
      await validationSchema.validate(formData, { abortEarly: false });
      // If validation passes, you can submit the form
      setErrorMessage(errors);
      // Call your API or perform other actions here
      handleBirthdayPoojaReport();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypes] = e.message;
          }
        });
      }
      setErrorMessage(errors);
    }
  };

  const [isDatePickerOpen, setDatePickerOpen] = useState(false);

  useEffect(() => {
    setDatePickerOpen(false);
  }, [formData.poojaWeek]);

  const handleDateChange = (field: keyof ErrorMessageTypes, value: any) => {
    const formattedDate = dayjs(value, "MM-DD-YYYY");
    // setCurrentItem((prevItem) => ({ ...prevItem, [field]: formattedDate.isValid() ? formattedDate.format('MM-DD-YYYY') : '' }));
    setFormData({
      ...formData,
      [field]: formattedDate.isValid()
        ? formattedDate.format("MM/DD/YYYY")
        : "",
    });
  };
  function disableExceptMondays(date: any) {
    // Check if date is a valid dayjs object
    if (!dayjs(date).isValid()) {
      return true; // Consider disabling the date if it's not a valid dayjs object
    }
  
    // Get the day of the week (0 for Sunday, 1 for Monday, and so on)
    const dayOfWeek = dayjs(date).day();
  
    // Disable all days except Mondays (day 1)
    return dayOfWeek !== 1;
  }
  const poojaWeekPicker = (): React.ReactElement => {
    return (
      <div className={styles.pookaWeekPickerContainer}>
        <StyledDateContainer
          sx={{
            backgroundColor: "#fff",
            borderRadius: "8px",
            height: "48px",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                shouldDisableDate={disableExceptMondays}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formData.poojaWeek
                    ? dayjs(formData.poojaWeek, "MM/DD/YYYY")
                    : ""
                }
                onChange={(value) => {
                  setErrorMessage({ ...errorMessage, poojaWeek: "" });
                  handleDateChange("poojaWeek", value);
                }}
                className={
                  errorMessage.poojaWeek
                    ? styles.errorTextField
                    : styles.textField
                }
              />
            </DemoContainer>
          </LocalizationProvider>
          {errorMessage.poojaWeek ? (
            <Typography sx={{ color: "red", fontSize: "12px" }}>
              {errorMessage.poojaWeek}
            </Typography>
          ) : (
            ""
          )}
        </StyledDateContainer>
      </div>
    );
  };

  return (
    <Grid spacing={2} sx={{display:"flex", flexDirection:"column", gap:"16px"}}>
      <Grid xs={12} sm={3} item className={styles.abhishekamReportsMainContainer}> 
        {poojaWeekPicker()}
      </Grid>
      <CommonOutlinedButton
        sx={{ width: "fit-content", height: "38px" }}
        onClick={handleSave}
        disabled={loading}
        id="submit"
      >
        <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
      </CommonOutlinedButton>
    </Grid>
  );
};
export default BirthdayPoojaReport;
